import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enTranslation from "./locales/en/translation.json";
import arTranslation from "./locales/ar/translation.json";

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: enTranslation,
            },
            ar: {
                translation: arTranslation,
            },
        },
        fallbackLng: "en",
        interpolation: {
            escapeValue: false,
        },
        detection: {
            order: ["localStorage", "navigator"],
            caches: ["localStorage"],
            lookupLocalStorage: "i18nextLng",
        },
        react: {
            useSuspense: false,
            bindI18n: "languageChanged loaded",
        },
        debug: false
    });

i18n.on("languageChanged", (lng) => {
    if (typeof document === "undefined") return;
    document.documentElement.lang = lng;
    // Apply text direction so `[dir="rtl"]` CSS rules take effect.
    // This must run on every load (not just on toggle) because LanguageToggle
    // does a full page reload, which resets the <html> element's dir attribute.
    // i18next fires `languageChanged` on init with the detected language, so
    // this restores RTL after a reload as well as on an explicit toggle.
    document.documentElement.dir = lng === "ar" ? "rtl" : "ltr";
});

// Apply direction immediately for the already-detected language, in case the
// initial `languageChanged` fired before the listener above was attached.
if (typeof document !== "undefined" && i18n.language) {
    document.documentElement.lang = i18n.language;
    document.documentElement.dir = i18n.language === "ar" ? "rtl" : "ltr";
}

export default i18n;
 